// extracted by mini-css-extract-plugin
export default {"notify":"Notify_notify__Wo1-e","close":"Notify_close__fzQEM","view":"Notify_view__G0w1s"};